var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160541",
    "data-name": "Group 160541",
    transform: "translate(-136 -1200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 16,
    height: 16,
    transform: "translate(136 1200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "stop-circle-outline",
    transform: "translate(139.877 1203.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M72.666,68.333a4.333,4.333,0,1,0-4.333,4.333A4.334,4.334,0,0,0,72.666,68.333Z",
    transform: "translate(-64 -64)",
    fill: "none",
    stroke: "#0032c5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M179.033,179.611h-2.455a.578.578,0,0,1-.578-.578v-2.455a.578.578,0,0,1,.578-.578h2.455a.578.578,0,0,1,.578.578v2.455A.578.578,0,0,1,179.033,179.611Z",
    transform: "translate(-173.472 -173.472)",
    fill: "#0032c5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectStopIcon);
export default __webpack_public_path__ + "static/media/MultiselectStop-icon.e790323bebaecdba2a73bcfb61201c29.svg";
export { ForwardRef as ReactComponent };